// extracted by mini-css-extract-plugin
module.exports = {"wordSlot":"SentenceConnectables_wordSlot__1wpig"};